import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(2),
  },
  searchFields: {
    width: '100%',
    margin: [theme.spacing(2), 0],
    [theme.breakpoints.up('mobile')]: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  field: {
    width: '100%',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('mobile')]: {
      width: '30%',
      marginBottom: 0,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/Search/useStyles.js